/** Configurable status values that track agenda items through the legislative lifecycle. */
export const legislativeStatusesCube = {
    category: 'Legislation',
    description: 'Legislative item status definitions used to track items through the lifecycle.',
    label: 'Legislative Item Statuses',
    requiredModule: 'hasAgenda',
    measures: {
        'legislative_statuses.count': { label: 'Count', type: 'number' },
    },
    dimensions: {
        'legislative_statuses.name': { label: 'Name', type: 'string' },
        'legislative_statuses.code': { label: 'Code', type: 'string' },
        'legislative_statuses.is_active': { label: 'Is Active', type: 'boolean' },
    },
    timeDimensions: {
        'legislative_statuses.created_at': { label: 'Created At', type: 'date' },
        'legislative_statuses.updated_at': { label: 'Updated At', type: 'date' },
    },
};
